import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
export const firebaseConfig = {
  apiKey: "AIzaSyCwauLCjwYWDJEwLiihmMKZyaqGXo8fiOY",
  authDomain: "izi-community.firebaseapp.com",
  projectId: "izi-community",
  storageBucket: "izi-community.appspot.com",
  messagingSenderId: "699131985609",
  appId: "1:699131985609:web:b0d5c824119b77eaf2d718",
  measurementId: "G-NVYSJ8RWTL"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore()
const auth = firebase.auth();
const storage = firebase.storage();
const baseUrl = "http://api.izi.community";
export {db, auth, storage, baseUrl}


